import { Logger } from "@core/helpers/logger.helpers";
import { LoadingManager } from "@core/managers/loading.manager";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { ETAB_ROUTES } from "@etab/config";
import { META_HTML_TITLE, TRANSITIONS } from "@core/constants";
import {
  ACTION_EXTRA_GET_BY_ID,
  ACTION_EXTRA_GET_SKILLS_BY_ID,
  ACTION_RECRUITMENTS_SET_SELECTED_EXTRA,
  GETTER_RECRUITMENT_GET_CURRENT,
  GETTER_EXTRA_GET_CURRENT,
  ACTION_EXTRA_GET_BIO_BY_ID,
  ACTION_EXTRA_GET_LANGUAGE_BY_ID,
  ACTION_EXTRA_GET_SKILLS,
  ACTION_EXTRA_GET_COURSES,
  ACTION_EXTRA_GET_EXPERIENCES,
} from "@etab/stores/types";
import { ACTION_TRANSITIONS_SET } from "@core/store/types";
import { useRecruitmentStore } from "@etab/stores/recruitment";
import { useRecruitmentsStore } from "@etab/stores/recruitments";
import { useExtraStore } from "@etab/stores/extra";
import { useCssTransitionsStore } from "@core/store/modules/cssTransitions";
import { repositoryManager } from "@extracadabra/infrastructure";

import MissionTab from "./Mission.tab.vue";
import ProfileTabV2 from "./Profile-v2.tab.vue";

import TemporaryCandidateRoot from "./TemporaryCandidate.root.vue";
export default function () {
  return [
    {
      path: ETAB_ROUTES.dashboard.recruitment.temporary.candidate.root.path,
      name: ETAB_ROUTES.dashboard.recruitment.temporary.candidate.root.name,
      meta: { [META_HTML_TITLE]: "ETAB.PAGES.EXTRA.@TITLE" },
      component: TemporaryCandidateRoot,
      async beforeEnter(to, from) {
        const recruitmentStore = useRecruitmentStore();
        const recruitmentsStore = useRecruitmentsStore();
        const extraStore = useExtraStore();
        try {
          // prepare the data
          LoadingManager.show();
          const recruitment = recruitmentStore[GETTER_RECRUITMENT_GET_CURRENT];
          const { demandType, candidateId, demandTemporaryId, demandId } = to.params;
          const type = recruitment.getType(); // "mer" or "temp" (for AE)
          const repository = repositoryManager.get("candidateProfile");
          // select the extra for future reference
          recruitmentsStore[ACTION_RECRUITMENTS_SET_SELECTED_EXTRA](candidateId);
          await extraStore[ACTION_EXTRA_GET_BY_ID]({
            extraId: candidateId,
            demandId: demandId,
            type,
          });
          await extraStore[ACTION_EXTRA_GET_BIO_BY_ID]({ demandId: demandTemporaryId, candidateId, repository });
          await extraStore[ACTION_EXTRA_GET_LANGUAGE_BY_ID]({ demandId: demandTemporaryId, candidateId, repository });
          await extraStore[ACTION_EXTRA_GET_SKILLS]({ demandId: demandTemporaryId, candidateId, repository });
          await extraStore[ACTION_EXTRA_GET_COURSES]({ demandId: demandTemporaryId, candidateId, repository });
          await extraStore[ACTION_EXTRA_GET_EXPERIENCES]({ demandId: demandTemporaryId, candidateId, repository });
          await extraStore[ACTION_EXTRA_GET_SKILLS_BY_ID]({ candidateId });
          const extra = extraStore[GETTER_EXTRA_GET_CURRENT];

          // RG: prevent the user to see an ignored (i.e. cancellation of shifts before mission starts) AE candidate
          if (recruitment.isAE() && extra.isIgnored()) {
            Logger.log("TemporaryCandidateRoot - Navigation prevented, Extra is ignored");
            // go back to recruitment detail
            return {
              name: ETAB_ROUTES.dashboard.recruitment.temporary.detail.root.name,
              params: { demandId, demandType },
            };
          }

          if (to.name === ETAB_ROUTES.dashboard.recruitment.temporary.candidate.root.name) {
            // RG: when undecided (went for root), go to the mission tab if it exists
            if (recruitment.isAE() && (extra.isSelected() || extra.isCanceled())) {
              return {
                name: ETAB_ROUTES.dashboard.recruitment.temporary.candidate.mission.name,
                params: { demandId, demandType, candidateId },
              };
            }
            // RG: otherwise any other situation will go to extra profile page
            return {
              name: ETAB_ROUTES.dashboard.recruitment.temporary.candidate.profile.name,
              params: { demandId, demandType, candidateId },
            };
          }

          return true;
        } catch (error) {
          const message = (error && error.message) || "ERRORS.@SOMETHING_WENT_WRONG";
          NotificationsManager.error({ message });
          return false; // Arrête la navigation en cas d'erreur
        } finally {
          LoadingManager.hide();
        }
      },
      children: [
        {
          path: ETAB_ROUTES.dashboard.recruitment.temporary.candidate.mission.path,
          name: ETAB_ROUTES.dashboard.recruitment.temporary.candidate.mission.name,
          beforeEnter(to, from) {
            const cssTransitionsStore = useCssTransitionsStore();
            const extraStore = useExtraStore();
            cssTransitionsStore[ACTION_TRANSITIONS_SET](TRANSITIONS.SLIDE.RIGHT);
            const extra = extraStore[GETTER_EXTRA_GET_CURRENT];
            const { demandId, demandType, candidateId } = to.params;

            if (!extra.isSelected() && !extra.isCanceled()) {
              // RG: do not see the mission tab if the extra was never selected
              // go to profile instead
              return {
                name: ETAB_ROUTES.dashboard.recruitment.temporary.candidate.profile.name,
                params: { demandId, demandType, candidateId },
              };
            }

            return true;
          },
          component: MissionTab,
        },
        {
          path: ETAB_ROUTES.dashboard.recruitment.temporary.candidate.profile.path,
          name: ETAB_ROUTES.dashboard.recruitment.temporary.candidate.profile.name,
          beforeEnter(to, from) {
            const cssTransitionsStore = useCssTransitionsStore();
            cssTransitionsStore[ACTION_TRANSITIONS_SET](TRANSITIONS.SLIDE.LEFT);
            return true;
          },
          component: ProfileTabV2,
        },
      ],
    },
  ];
}
